

module.exports = __webpack_require__.stylable.create(
    "ToggleSwitch354613264",
    {"classes":{"root":"ToggleSwitch354613264__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "ToggleSwitch354613264",
    null
);
